import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ tokens }) => ({
  wrapper: {
    '&:hover': {
      backgroundColor: tokens.colors.bg.greyscale.tertirary,
    },
  },
}));
